import React from 'react'

const Separator = (props) => {
    return (
        <hr/>
    )
}

export default Separator
